import { BASE_QUERY_PRO, DEFAULT_SECTION_TOP_COUNT, ruleNewsPlus } from '../shared/configs';

enum SECTION_ENUM {
  COMMENTARY_AND_ANALYSIS = 'Commentary & Analysis',
  ECONOMY = 'Economy',
  RESEARCH = 'Research',
  FINANCIAL_REGULATION = 'Financial Regulation'
}

const SECTION_TYPES = {
  CENTRAL_BANKS: 'central banks',
  CENTRAL_BANKS_COMMENTARY: 'central banks commentary',
  CENTRAL_BANKS_RESEARCH: 'central banks research'
};

const PRIMARY_DJE_THINGS = {
  ECONOMY: 'economy',
  ECONOMY_CENTRAL_BANKING: 'economy/central-banking',
  FINANCE_CURRENCIES: 'finance/currencies',
  FINANCE_REGULATION: 'finance/regulation'
};

const MAIN = {
  ...BASE_QUERY_PRO,
  query: {
    ...BASE_QUERY_PRO.query,
    or: [
      {
        terms: {
          key: 'SectionType',
          value: [SECTION_TYPES.CENTRAL_BANKS]
        }
      },
      {
        terms: {
          key: 'PrimaryDJEThing',
          value: [PRIMARY_DJE_THINGS.ECONOMY_CENTRAL_BANKING, PRIMARY_DJE_THINGS.FINANCE_CURRENCIES]
        }
      }
    ],
    not: [...BASE_QUERY_PRO.query.not, ruleNewsPlus]
  }
};

const SECTION_TOP = {
  ...MAIN,
  ...DEFAULT_SECTION_TOP_COUNT
};

const COMMENTARY_AND_ANALYSIS = {
  ...BASE_QUERY_PRO,
  query: {
    ...BASE_QUERY_PRO.query,
    or: [{ terms: { key: 'SectionType', value: [SECTION_TYPES.CENTRAL_BANKS_COMMENTARY] } }]
  }
};

const ECONOMY = {
  ...BASE_QUERY_PRO,
  query: { ...BASE_QUERY_PRO.query, or: [{ terms: { key: 'DJEThing', value: [PRIMARY_DJE_THINGS.ECONOMY] } }] }
};

const RESEARCH = {
  ...BASE_QUERY_PRO,
  query: {
    ...BASE_QUERY_PRO.query,
    or: [{ terms: { key: 'SectionType', value: [SECTION_TYPES.CENTRAL_BANKS_RESEARCH] } }]
  }
};

const FINANCIAL_REGULATION = {
  ...BASE_QUERY_PRO,
  query: {
    ...BASE_QUERY_PRO.query,
    or: [{ terms: { key: 'DJEThing', value: [PRIMARY_DJE_THINGS.FINANCE_REGULATION] } }]
  }
};

export { MAIN, SECTION_TOP, COMMENTARY_AND_ANALYSIS, ECONOMY, RESEARCH, FINANCIAL_REGULATION, SECTION_ENUM };
